module.exports = __webpack_public_path__ + "img/trees.c77f9c89.jpg";